module.exports = __webpack_public_path__ + "static/media/kids_15.e0c13c17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_15.jpg
// module id = 5871
// module chunks = 0